import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextInput } from '@parsina/framework';

import { useTranslation } from '../../i18n';
import { StepHeading, PrimaryAction } from '../../components/auth/OnboardingParts.jsx';
import { TRACK, writeQuickPlan } from './quickSetup.js';

/**
 * «ساخت کلینیک» — what «پزشک نیستم» on «شروع» opens: the clinic's name, and
 * nothing else.
 *
 * Everything the full form asked is either decided by Parsina's defaults
 * (quickSetup.js) or left for «کلینیک من». The full form is still where the
 * switcher's «افزودن کلینیک» goes, and where a number from abroad registers.
 */
export default function QuickClinicNameStep({ disabled = false }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [name, setName] = React.useState('');
  const [error, setError] = React.useState('');

  const submit = (e) => {
    e?.preventDefault?.();
    if (disabled) return;
    const trimmed = name.trim();
    if (!trimmed) { setError(t('validation.clinic.nameRequired')); return; }
    if (trimmed.length < 2) { setError(t('validation.clinic.nameTooShort')); return; }
    writeQuickPlan({ track: TRACK.CLINIC, clinicName: trimmed });
    navigate('/onboarding?quick=run', { replace: true });
  };

  return (
    <form onSubmit={submit} noValidate data-testid="quick-clinic-name">
      <StepHeading title={t('clinic.quickSetup.nameTitle')} subtitle={t('clinic.quickSetup.nameBody')} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <TextInput
          label={t('auth.createClinic.nameLabel')}
          required
          value={name}
          onChange={(e) => { setName(e.target.value); setError(''); }}
          placeholder={t('auth.createClinic.namePlaceholder')}
          helperText={error ? undefined : t('clinic.quickSetup.nameHelper')}
          error={error || undefined}
          maxLength={120}
          autoFocus
          autoComplete="off"
          disabled={disabled}
          data-testid="quick-clinic-name-input"
        />
        <PrimaryAction fullWidth type="submit" disabled={disabled} data-testid="quick-clinic-name-submit">
          {t('clinic.quickSetup.nameSubmit')}
        </PrimaryAction>
        <Button variant="link" type="button" onClick={() => navigate('/start')} data-testid="quick-clinic-name-back">
          {t('common.actions.back')}
        </Button>
      </div>
    </form>
  );
}
